<div class="group3">
  <h4 style="margin-top: 0;" *ngIf="!hidetitle"> Infos dét. </h4>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht53">
    <label class="col-sm-3 champ" style="padding:0px"> Fax :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.fax }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.fax">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht54">
    <label class="col-sm-3 champ" style="padding:0px"> Mail :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.mail }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.mail">
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht55">
    <label class="col-sm-3 champ" style="padding:0px"> Portable1 : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.portable1 }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.portable1">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht56">
    <label class="col-sm-3 champ" style="padding:0px"> Portable2 : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{chantier.portable2}} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.portable2">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht57">
    <label class="col-sm-3 champ" style="padding:0px"> Code activité : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <!--combo => aucun (0) = globalparam 77 -->
      <div *ngIf="!edit"> {{ chantier.codeActiviteDetenteur ? (chantier.codeActiviteDetenteur.libelle || codeActivite) : 'Aucun' }} </div>
      <div *ngIf="edit">
        <app-autocomplete (selectfunction)="chantier.codeActiviteDetenteur = $event" [results]="resultType"
          [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="chantier.codeActiviteDetenteur"
          [defaultsearch]="chantier.codeActiviteDetenteur ? (chantier.codeActiviteDetenteur.libelle || codeActivite) : 'Aucun'">
        </app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht58">
    <label class="col-sm-3 champ" style="padding:0px"> Nbr de personne : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.nbrHabitant }} </div>
      <input *ngIf="edit" type="number" class="form-control" [(ngModel)]="chantier.nbrHabitant">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht59">
    <label class="col-sm-3 champ" style="padding:0px"> Nbr et type logement : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <!--type button-->
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht60">
    <label class="col-sm-3 champ" style="padding:0px"> Sup. terrain : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.superficieTerrain }} </div>
      <input *ngIf="edit" type="numbre" class="form-control" [(ngModel)]="chantier.superficieTerrain">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht61">
    <label class="col-sm-3 champ" style="padding:0px"> Observation : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit" [innerHTML]="chantier.observation"></div>
      <textarea *ngIf="edit" class="form-control" rows="3" [(ngModel)]="chantier.observation"></textarea>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht62">
    <label class="col-sm-3 champ" style="padding:0px"> Gardien : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.gardien }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.gardien">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht63 || common.visibleChamp.cht64 ||common.visibleChamp.cht65">
    <label class="col-sm-3 champ" style="padding:0px">
      Adresse :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit && common.visibleChamp.cht63"> {{ chantier.adresse1Gardien }} </div>
      <div *ngIf="!edit && common.visibleChamp.cht64"> {{ chantier.adresse2Gardien }} </div>
      <div *ngIf="!edit && common.visibleChamp.cht65"> {{ chantier.adresse3Gardien }} </div>
      <div *ngIf="edit && common.visibleChamp.cht63">
        <app-autocomplete *ngIf="adresseAutoBAK" [placeholder]="'Adresse'" (searchfunction)="searchAdresseBAK($event)"
          (selectfunction)="setValueAdresseBAK($event, 'client')" [results]="dataAdresseBAK" [container]="true"
          [defaultsearch]="chantier.adresse1Gardien ? chantier.adresse1Gardien : ''" [minlength]="3"  [nePasCompterEspace]="true">
        </app-autocomplete>
        <input *ngIf="edit && !adresseAutoBAK" type="text" class="form-control"
          [(ngModel)]="chantier.adresse1Gardien" [readonly]="adresseAutoBAK">
      </div>
      <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.adresse1Gardien"
        [readonly]="adresseAutoBAK"-->
      <input *ngIf="edit && common.visibleChamp.cht64" type="text" class="form-control" [(ngModel)]="chantier.adresse2Gardien"
        [readonly]="adresseAutoBAK" style="margin-top: 5px; margin-bottom: 5px;">
      <input *ngIf="edit && common.visibleChamp.cht65" type="text" class="form-control" [(ngModel)]="chantier.adresse3Gardien"
        [readonly]="adresseAutoBAK">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht66">
    <label class="col-sm-3 champ" style="padding:0px">
      Code Pos :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.cpGardien }} </div>
      <div *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'cpGardien'" [item]="chantier" [ville]="'villeGardien'" [iscp]="true"
          [disable]="adresseAutoBAK">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht67">
    <label class="col-sm-3 champ" style="padding:0px">
      Ville :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.villeGardien }} </div>
      <div *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'cpGardien'" [item]="chantier" [ville]="'villeGardien'"
          [disable]="adresseAutoBAK">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht68">
    <label class="col-sm-3 champ" style="padding:0px"> Tel : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.telGardien }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.telGardien">
    </div>
  </div>
  <div class="form-group items col-sm-12"  *ngIf="common.visibleChamp.cht69">
    <label class="col-sm-3 champ" style="padding:0px"> Agence : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.agence ? common.getItem(listeagence, chantier.agence.id) : ''}} </div>
      <div *ngIf="edit">
        <app-autocomplete (selectfunction)="chantier.agence = $event" [results]="resultAgence" [highlight]="true"
          [id]="'modedepaie'" [isCombo]="true" [defaultselected]="chantier.agence"
          [defaultsearch]="chantier.agence ? (chantier.agence.libelleObjetEntite || chantier.agence.libelle) : ''"></app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.cht70">
    <label class="col-sm-3 champ" style="padding:0px">Num Badge :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{ chantier.numBadgeDecheterie }} </div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="chantier.numBadgeDecheterie">
    </div>
  </div>
</div>